import {
  FETCH_CAMPAIGN_INIT,
  FETCH_CAMPAIGN_SUCCESS,
  FETCH_CAMPAIGN_ERROR,
} from 'containers/Player/actions/campaign/constants';
import { CLEAR_PLAYER_DATA } from '../actions/player/constants';

const initialState = {
  loading: null,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CAMPAIGN_INIT:
      return { ...state, loading: true, data: null, error: null };
    case FETCH_CAMPAIGN_SUCCESS:
      return { ...state, loading: false, data: action.data, error: null };
    case FETCH_CAMPAIGN_ERROR:
      return { ...state, loading: false, data: null, error: action.error };
    case CLEAR_PLAYER_DATA:
      return initialState;
    default:
      return state;
  }
};
